import ViewAccountManagementTaskList from "../../features/AccountManagement/ViewAccountManagementTaskList"
import "./AccountManagement.scss"

const ViewAccountTaskList = () => {
    return (
        <ViewAccountManagementTaskList/>
    )
}

export default ViewAccountTaskList